import { GET_ALL_ORDERS, GET_ALL_ORDERS_SUCCESS, GET_ALL_ORDERS_FAIL } from "./actionTypes";


export const getAllOrders = () => ({
  type: GET_ALL_ORDERS,
  payload: {
    loading: true
  }
});

export const getAllOrdersSuccess = (data) => {
  return ({
    type: GET_ALL_ORDERS_SUCCESS,
    payload: {
      data,
      loading: false,
    },
  });
};

export const getAllOrdersFail = (error) => ({
  type: GET_ALL_ORDERS_FAIL,
  payload: {
    error,
    loading: false,
  },
});
